<script>
  export default {
    name: "AtomRadioButton",
    props: {
      label: {
        type: String,
        default: "Radio Button",
      },
      value: {
        type: [String, Number, Boolean],
        default: null,
      },
      name: {
        type: String,
        default: "radioGroup",
      },
      checked: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      tabindex: {
        type: [Number, String],
        default: null,
      },
      description: {
        type: String,
        default: "",
      },
    },
  };
</script>

<template>
  <div class="radioButton">
    <input class="radioButton__input" type="radio" :id="`radio-${name}-${value}`" :name="name" :value="value" :checked="checked" :disabled="disabled" :tabindex="tabindex" />
    <div class="radioButton__labelContainer">
      <label class="radioButton__label" :for="`radio-${name}-${value}`" :class="{ 'radioButton__label--selected': checked }">{{ label }}</label>
      <p class="radioButton__description" v-if="description" v-html="description"></p>
    </div>
  </div>
</template>

<style lang="scss">
  .radioButton {
    display: flex;
    align-items: center;
    gap: 11px;

    &__input {
      width: 18px;
      height: 18px;
      flex-shrink: 0;
      border-radius: 50%;
      border: 1px solid #c4c4c4;
      appearance: none;
      cursor: pointer;
      background: white;
      transition: all 0.2s ease;

      &:checked {
        border: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Crect x='2.5' y='2.5' width='13' height='13' rx='6.5' stroke='%23BD0909' stroke-width='5'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }

      &:disabled {
        border-color: #ccc;
        background-color: #f5f5f5;
        cursor: not-allowed;
      }
    }
    &__labelContainer {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      width: 100%;
      gap: 4px;
    }
    &__label {
      color: #3d3d3d;
      text-align: center;
      font-size: 16px;
      font-family: $newFont_regular;
      font-weight: 500;
      cursor: pointer;
      user-select: none;
    }
    &__description {
      color: #595959;
      font-size: 12px;
      font-family: $newFont_regular;
    }

    &__label--selected {
      font-family: $newFont_medium;
    }

    &__input:disabled + &__label {
      color: #ccc;
      cursor: not-allowed;
    }
  }
</style>
